<template>
  <div
    class="bg-gray-800 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 w-full"
  >
    <div class="p-6">
      <div class="flex items-center justify-between mb-4">
        <div class="flex items-center">
          <!-- Avatar placeholder -->
          <div
            class="bg-gray-700 h-12 w-12 rounded-full flex items-center justify-center text-green-500 text-xl font-semibold mr-3"
          >
            {{ getUserInitials() }}
          </div>

          <div>
            <router-link
              :to="`/profile/${user.id}`"
              class="text-blue-400 font-semibold hover:text-blue-300 transition-colors"
            >
              {{ user.username }}
            </router-link>
            <div class="flex items-center mt-1 text-purple-400">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-1"
                viewBox="0 0 24 24"
                stroke="currentColor"
                fill="none"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <span class="text-sm">{{ user.city }}</span>
            </div>
          </div>
        </div>

        <button
          @click.stop.prevent="toggleFollow"
          class="bg-gray-700 hover:bg-gray-600 text-white px-3 py-2 rounded-md text-sm transition-colors flex items-center"
          :class="{ 'opacity-70': isLoading }"
          :disabled="isLoading"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-1"
            :class="{ 'text-red-400': true }"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
              clip-rule="evenodd"
            />
          </svg>
          Otprati
        </button>
      </div>

      <div class="flex items-center mt-4">
        <router-link
          :to="`/profile/${user.id}`"
          class="text-green-500 hover:text-green-400 transition-colors text-sm flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
            <path
              fill-rule="evenodd"
              d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
              clip-rule="evenodd"
            />
          </svg>
          Pogledaj profil
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'UserCard',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  emits: ['unfollow'],
  setup(props, { emit }) {
    const isLoading = ref(false);

    const getUserInitials = () => {
      return props.user.username.charAt(0).toUpperCase();
    };

    const toggleFollow = async (event: Event) => {
      // Prevent event propagation
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (isLoading.value) return;

      isLoading.value = true;

      try {
        emit('unfollow', props.user.id);
      } catch (error) {
        console.error('Error unfollowing user:', error);
      } finally {
        isLoading.value = false;
      }
    };

    return {
      isLoading,
      getUserInitials,
      toggleFollow,
    };
  },
});
</script>
